/* Gogo Language Texts
Table of Contents
01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/
import countryList from "./ar_country_list";

export default () => {
  return {
    /* 00. Languages */
    en: "English",
    tr: "Turkish",
    de: "German",
    ar: "Arabic",

    /* 01.General */
    countryList,
    "Network Error!": "خطأ في الشبكة!",
    Reconnecting: "أعد الاتصال",
    "Retry Now": "حاول مرة أخرى الآن",
    "Please allow notifications": "يرجى السماح بالإخطارات",
    "Please check your internet connection": "الرجاء التحقق من اتصال الانترنت الخاص بك",
    "You are currently offline": "أنت حاليا غير متصل",
    "Old Version": "نسخة قديمة",
    "Your version is old. Please refresh your browser to reload!": "نسختك قديمة. الرجاء الضغط هنا لتحديث المتصفح الخاص بك",
    connected_to_the_server: "متصل بالخادم",
    this_user_does_not_have_permission_for_this_hotel: "هذا المستخدم ليس لديه إذن لهذا الفندق",
    permission_error: "خطأ في الإذن",
    dateOptions: {
      yearFormat: "numeric",
      monthFormat: "long",
      dayFormat: "2-digit",
      locale: "ar-AR"
    },
    click_to_load: "انقر لتحميل المزيد.",
    click_to_load_until: "تظهر حتى ",
    click_to_load_number: "عرض (",
    seen_all: "لقد رأيت كل شيء.",

    birthdate_format: "DD/MM/YY",
    // 'form.valid.peopleCount': 'people count is required and must be greater then 0',
    // 'form.valid.childCount': '',

    "form.valid.firstname": "الإسم الأول مطلوب",
    "form.valid.lastname": "إسم العائلة مطلوب",
    "form.valid.price": "المبلغ غير صالح",
    "form.valid.email": "البريد الإلكتروني غير صحيح",
    "form.valid.mobile": "رقم الهاتف غير صحيح - على سبيل المثال:123xxxxxxxxx+",
    "form.valid.roomnumber": "رقم الغرفة غير صالح",
    "form.valid.decimal": "القيمة العشرية غير صحيحة",
    "link.WeBeeCode": "رمز Webee:",
    "link.copyCode": "نسخ كود Webee",
    "link.header": "إنشاء عنوان URL للدفع",
    "link.modalheader": " الرابط",
    "link.copy": "انسخ الرابط",
    "link.error": "حدث خطأ ما. أعد المحاولة من فضلك!",
    "createQr.create_link": "قم بإنشاء QR للحصول على رابط التنزيل",
    "createQr.create_booking_with_pms": "إنشاء QR لـ PMS",
    "createQr.success": "إنشاء نجاح QR",
    "createQr.error": "حدث خطأ ما. أعد المحاولة من فضلك!",
    "link.goReport": "صفحات التقارير",
    "link.copied": "نسخ إلى الحافظة",
    "report.expired": "منتهي الصلاحية",
    "report.not_expired": "متوفرة",
    "report.header": "تقرير",
    "report.pay": "مدفوع",
    "report.not_pay": "لا أجر",
    "report.no_payments": "لا مدفوعات",
    "report.permisson_error_payments": "ليس لديك حق دخول هنا",
    "forms.firstname": "الاسم الاول",
    "forms.lastname": "اللقب",
    "forms.price": "مقدار:",
    "forms.email": "البريد الإلكتروني",
    "forms.start_date": "تاريخ البدء",
    "forms.end_date": "تاريخ الانتهاء",
    "forms.mobile": "رقم الهاتف:",
    "forms.phone_number": "١ ٢ ٣ xxxxxx+",
    "forms.check_in_check_out": "تسجيل دخول تسجيل خروج:",
    "forms.generate": "إنشاء عنوان URL",
    "forms.please_select": "الرجاء تحديد",
    "forms.create": "إنشاء ",
    "forms.checkin": "تاريخ الدخول",
    "forms.checkout": "تاريخ الخروج",
    "forms.room_number": "رقم الغرفة",
    "forms.send_sms": "إرسال الرسائل القصيرة",
    "forms.send_email": "ارسل بريد الكتروني",
    "forms.select_contact": "يمكنك اختيار معلومات جهة الاتصال",
    "forms.select_pms": "قائمة الضيوف",
    "alacarte.grand_total": "المبلغ الإجمالي",
    "alacarte.total_order": "إجمالي الطلبات",
    "alacarte.restaurant_name": "اسم المطعم",
    "alacarte.request_time": "طلب الوقت",
    "alacarte.restaurants_header": "المطاعم",
    "alacarte.no_restaurants": "لا يوجد مطاعم",
    "alacarte.mondays": "الاثنين",
    "alacarte.tuesdays": "يوم الثلاثاء",
    "alacarte.wednesdays": "الأربعاء",
    "alacarte.thursdays": "يوم الخميس",
    "alacarte.fridays": "جمعة",
    "alacarte.saturdays": "أيام السبت",
    "alacarte.sundays": "أيام الأحد",
    "alacarte.quota": "شخص",
    "alacarte.days": "أيام",
    "alacarte.success": "النجاح",
    "alacarte.addSlot": "إضافة ",
    "alacarte.reservation_slot": "فتحة الحجز",
    "alacarte.removeSlot": "إزالة الفتحة",
    "alacarte.stop_res_before_opens_at": "توقف الحجز قبل الوقت المحدد ",
    "alacarte.guest_cancel_res_before_open_at": "يمكن للضيف إلغاء الحجز قبل فتحها",
    "alacarte.max_guest_count": "يمكن لأقصى عدد من الأشخاص إجراء الحجز",
    "alacarte.guest_one_res_each_day": "يمكن للضيف حجز واحد كل يوم",
    "alacarte.guest_one_res_per_resturant": "يمكن للضيف حجز واحد لكل مطعم",
    "alacarte.yes": "نعم",
    "alacarte.no": "لا",
    "alacarte.alacarte": "حسب الطلب",
    "alacarte.no_config": "لا تكوين",
    "alacarte.newRequest": "طلب جديد",
    "alacarte.print": "إطبع",
    "alacarte.request_owner_staff": "صاحب الطلب هو الموظف",
    "alacarte.allday": "طوال اليوم",
    "alacarte.available_seats": "المقاعد المتاحة",
    "alacarte.info_available_seats": "لا توجد فتحات زمنية مختارة بعد",
    "alacarte.main_course": "الدورات الرئيسة",
    "alacarte.person": "شخص",
    "alacarte.adult": "بالغ",
    "alacarte.adult_count": "عدد الكبار",
    "alacarte.child": "طفل",
    "alacarte.room_number": "رقم الغرفة",
    "alacarte.name": "اسم العائلة",
    "alacarte.notes": "ملحوظات",
    "alacarte.select_restaurant_and_slot": "حدد المطعم والوقت المتاح",
    "alacarte.people_count": "عدد الناس",
    "alacarte.child_count": "عدد الأطفال",
    "alacarte.create_form": "إنشاء نموذج",
    "alacarte.create_request": "إنشاء طلب",
    "alacarte.request_person_info": "معلومات الشخص",
    "alacarte.request_no_person_info": "لا يوجد معلومات عن الشخص ",
    "alacarte.input_required": "(*) يجب ملء حقول الإدخال المطلوبة.",
    "alacarte.count": "عدد",
    "alacarte.date": "تاريخ",
    "alacarte.time": "الوقت",
    "alacarte.total_request": "إجمالي الطلب",
    "alacarte.total_person": "إجمالي الأشخاص",
    "alacarte.total_child": "إجمالي الأطفال",
    "fastCheckin.guests": "نزلاء",
    "user.signout": "خروج",
    "user.login-title": "تسجيل الدخول",
    "user.gsmNo": "رقم الموبايل :",
    "user.sendCode": "إرسال الرمز",
    "user.resendCode": "أعد إرسال الرمز",
    "user.confirmationCode": "تأكيد الرمز",
    "user.cancel": "يلغي",
    "user.close": "تسكير",
    "user.modalChangePassword": "غير كلمة السر",
    "user.resetPassword": "إعادة تعيين كلمة السر",
    "user.changePassword": "غير كلمة السر",
    "user.passwordChangeSuccess": "تم تغيير كلمة السر الخاصة بك",
    "user.passwordChangeError": "حدث خطأ ما. أعد المحاولة من فضلك!",
    "user.oldPassword": "كلمة السر القديمة",
    "user.newPassword": "كلمة السر الجديدة",
    "user.confirmPassword": "تأكيد كلمة السر",
    "user.register": "يسجل",
    "user.forgot-password": "هل نسيت كلمة السر",
    "user.email": "البريد الإلكتروني",
    "user.note": "ملحوظة",
    "user.all_number": "كل الأرقام",
    "user.password": "كلمة السر",
    "user.forgot-password-question": "نسيت كلمة السر؟",
    "user.fullname": "الاسم الكامل",
    "user.login-button": "تسجيل الدخول",
    "user.register-button": "تسجيل",
    "user.reset-password-button": "إعادة تعيين",
    "user.buy": "يشترى",
    "user.username": "اسم المستخدم",
    "user.create": "إنشاء التكوين",
    "user.update": "تحديث التكوين",
    "menu.requests": "الطلبات",
    "menu.fastCheckin": "تسجيل الوصول الإلكتروني ",
    "menu.logs": "سجلات النزلاء",
    "menu.lolRequests": "طلبات أرض الأساطير",
    "menu.bookings": "الحجوزات",
    "menu.payments": "المدفوعات",
    "menu.settings": "إعدادات",
    "menu.template": "قوالب الرسائل",
    "menu.reportProblem": "الإبلاغ عن مشكلة",
    "menu.problemDescription": "وصف المشكلة",
    "menu.chooseTopic": "اختر عنوان الموضوع",
    "menu.descriptionFieldCannotLeftEmpty": "لا يمكن ترك حقل الوصف فارغًا",
    "menu.problemSubject": "موضوع المشكلة",
    "menu.sendReport": "إرسال تقرير",
    "menu.sendReportConfirmMessage": "هل أنت متأكد من إرسال التقرير؟",
    "menu.link": "إنشاء رابط",
    "menu.report": "تقرير الدفع",
    "menu.app": "الصفحة الرئسية",
    "menu.staff": "العاملين",
    "menu.dashboards": "لوحات المعلومات",
    "menu.gogo": "جوجو",
    "menu.start": "بداية",
    "menu.second-menu": "القائمة الثانية",
    "menu.second": "ثانيا",
    "menu.ui": "واجهة المستخدم",
    "menu.charts": "الرسوم البيانية",
    "menu.chat": "دردشة",
    "menu.survey": "الدراسة الاستقصائية",
    "menu.request": "الطلبات",
    "menu.search": "يبحث",
    "menu.docs": "مستندات",
    "menu.blank-page": "صفحة فارغة",
    "menu.empty_badge": "لا يوجد إشعارات جديدة",
    "menu.alacarte": "حجوزات حسب الطلب ",
    "menu.restaurant": "المطاعم",
    "menu.ringTone": "تغييرالنغمة ",
    "pages.error-title": "Ooops ... يبدو أن خطأ حدث!",
    "pages.error-code": "خطا بالكود",
    "pages.go-back-home": "ارجع الى الصفحة الرئسية ",
    "pages.display-options": "خيارات العرض",
    "pages.orderby": "ترتيب حسب : ",
    "request.payable": "طلب الدفع",
    "request.payable_status": "حالة السداد",
    "request.payable_total_amount": "المبلغ الإجمالي",
    "request.payable_currency": "عملة",
    "request.payable_payment": "دفع",
    "request.no_payable_details": "لا تفاصيل حتى الآن",
    "request.payable_status_paid": "مدفوع",
    "request.payable_status_canceled": "ألغيت",
    "request.payable_status_awaiting_payment": "انتظار الدفع",
    "request.order_number": "مكان الطلب",
    "request.add-new": "طلب جديد",
    "request.add-new-title": "إنشاء طلب جديد",
    "request.comment": "تعليق",
    "request.due": "تاريخ الاستحقاق",
    "request.title": "عنوان",
    "request.detail": "التفاصيل",
    "request.category": "نوع الخدمة",
    "request.label": "مُلصَق",
    "request.status": "حالة",
    "request.cancel": "يلغي",
    "request.submit": "يُقدِّم",
    "request.error": "الرجاء تحديد نوع الخدمة على الأقل",
    "request.action": "عمل",
    "request.another-action": "عمل آخر",
    "request.display-options": "خيارات العرض",
    "request.orderby": "ترتيب حسب : ",
    "request.all-tasks": "جميع الأعمال ",
    "request.pending-tasks": "قيد الانتظار",
    "request.open-tasks": "فتح",
    "request.completed-tasks": "مغلق",
    "request.canceled-tasks": "ألغيت",
    "request.list_status_canceled": "ألغيت",
    "request.categories": "أنواع",
    "request.labels": "ملصقات",
    "request.clear": "مسح",
    "request.guest": "نزيل",
    "request.details": "تفاصيل",
    "request.room": "غرفة",
    "request.collapse_all": "انهيار جميع الأعمال",
    "request.expand_all": "توسيع الكل",
    "request.request_details": " تفاصيل الطلب",
    "request.no_booking_info": "لا معلومات الحجز",
    "request.chat_say_something": "أرسل رسالة إلى النزيل ...",
    "request.message_title": "رسائل",
    "request.last_update": "اخر تحديث: ",
    "request.created_at": "أنشئت في: ",
    "request.Creation Date": "تاريخ الإنشاء",
    "request.Last Update": "اخر تحديث",
    "request.Due Date": "تاريخ الاستحقاق",
    "request.Guest Name": "اسم النزيل",
    "request.Service Name": "اسم الخدمة",
    "request.due_date": "تاريخ الاستحقاق: ",
    "request.empty_message_box": "لا توجد رسائل",
    "request.message_send_button": "إرسال",
    "request.upload": "تحميل",
    "request.wrong_request_page": "لا يوجد مثل هذا الطلب",
    "request.awaiting_approval_status_message": "أولاً، يجب عليك تحديث حالة الحجز للضيف لاتخاذ أي إجراء بخصوص الطلب",
    "request.empty_request_list": "لا طلبات",
    "request.details_action_re_open": "إعادة فتح",
    "request.Status": "حالة",
    "request.status_open": "فتح",
    "request.status_pending": "قيد الانتظار",
    "request.status_closed": "مغلق",
    "request.status_canceled": "ألغيت",
    "request.details_action_submit_as_resolved": "إرسال كما تم حله",
    "request.clear_filters": "مسح المرشحات",
    "request.back_button": "خلف",
    "request.message_view_translation": "عرض الترجمة",
    "request.message_show_original": "إظهار النسخة الأصلية",
    "request.message_translation_detect": "مُكتَشَف",
    "request.message_translation": "ترجمة",
    "request.pageUp": "أعلى",
    "request.create_qr": "إنشاء QR",
    "request.webeepass_message": "Scan code to download app and once download is completed, scan code to activate membership.",
    "request.modalCreateQR": "WeBee PASS",
    "request.survey_score": "علامة الاستطلاع",
    "request.create_qr_pms": "WeBee PASS",
    "booking.guest_information_form": "نموذج معلومات النزيل",
    "booking.signature": "التوقيع",
    "booking.date": "تاريخ",
    "booking.full_name": "اسم الكامل",
    "booking.has_traveled": "لقد سافرت في آخر 14 يومًا.",
    "booking.billing_address": "عنوان مستخدم الفواتير",
    "booking.passport_front": "جبهة جواز السفر",
    "booking.passport_back": "عودة جواز السفر",
    "booking.address": "عنوان",
    "booking.city": "مدينة",
    "booking.country": "دولة",
    "booking.town_of_registry": "بلدة التسجيل",
    "booking.city_of_registry": "مدينة التسجيل",
    "booking.serial_number": "رقم SN",
    "booking.document_type": "نوع الوثيقة",
    "booking.date_of_issue": "تاريخ المسألة",
    "booking.date_of_expire": "تاريخ الانتهاء",
    "booking.birth_place": "مكان الولادة",
    "booking.mother_name": "اسم الأم",
    "booking.father_name": "اسم الأب",
    "booking.dietary_requirements": "المتطلبات الغذائية إن وجدت",
    "booking.postal_code": "رمز بريدي",
    "booking.arrival_flight": "وصول الرحلة",
    "booking.departure_flight": "رحلة المغادرة",
    "booking.visa_type": "نوع الفيزا",
    "booking.visa_expiry_date": "تاريخ انتهاء التأشيرة",
    "booking.room_assignment": "تعيين الغرفة",
    "booking.OK": "نعم",
    "booking.car_plate": "لوحة السيارة",
    "booking.reservation_channel": "قناة الحجز",
    "booking.time_of_arrival_at_hotel": "وقت الوصول إلى الفندق",
    "booking.all-reservations": "جميع الحجوزات",
    "booking.status_hotel_guest": "نزيل فندق",
    "booking.status_future_guest": "نزيل المستقبل",
    "booking.status_awaiting_approval": "انتظر القبول",
    "booking.status_invalid_booking": "حجز غير صالح",
    "booking.status_checked_out": "إنهاء معاملات المغادرة",
    "booking.molainn_keyless_access_status_verified": "تم التحقق",
    "booking.molainn_keyless_access_status_pending": "قيد الانتظار",
    "booking.molainn_keyless_access_status_rejected": "مرفوض",
    "booking.molainn_keyless_access_status_expired": "منتهي الصلاحية",
    "booking.molainnKeylessAccessWarningMessage": "لمنح إذن فتح الباب، يجب عليك تغيير حالة الإقامة إلى ‘فندق ضيف’.",
    "booking.add-new": "إضافة جديدة",
    "booking.firstname-label": "الاسم الاول",
    "booking.lastname-label": "إسم العائلة",
    "booking.internal-notes-label": "ملاحظات داخلية",
    "booking.phone-label": "هاتف",
    "booking.firstname-placeholder": "الاسم الاول",
    "booking.lastname-placeholder": "اإسم العائلة",
    "booking.internal-notes-placeholder": "ملاحظات داخلية",
    "booking.phone-placeholder": "رقم الهاتف",
    "booking.add-new-modal-title": "إنشاء حجز جديد",
    "booking.empty_booking_list": "لا حجوزات",
    "booking.label": "مُلصَق",
    "booking.status": "حالة",
    "booking.submit": "يُقدِّم",
    "booking.cancel": "يلغي",
    "booking.room": "غرفة",
    "booking.checkin": "وصول",
    "booking.booking_summary": "تفاصيل الحجز",
    "booking.checkout": "مغادرة",
    "booking.display-options": "خيارات العرض",
    "booking.orderby": "ترتيب حسب : ",
    "booking.hescode": "رمز HES",
    "booking.TM6Form_number": "رقم نموذج TM6",
    "booking.empty_request_list": "لا حجوزات",
    "booking.wrong_booking_page": "لا يوجد مثل هذا الحجز",
    "bookingDetails.hotel_guest": "نزيل فندق",
    "bookingDetails.future_guest": "نزيل المستقبل",
    "bookingDetails.awaiting_approval": "انتظر القبول",
    "bookingDetails.invalid_booking": "حجز غير صالح",
    "bookingDetails.checked_out": "إنهاء معاملات المغادرة",
    "bookingDetails.reservation_number": "رقم الحجز",
    "bookingDetails.national_identification_number": "رقم الهوية الوطنية",
    "bookingDetails.passport_number": "رقم جواز السفر",
    "bookingDetails.birth_date": "تاريخ الميلاد",
    "bookingDetails.checkin_checkout": "تسجيل دخول تسجيل خروج",
    "bookingDetails.checkin_checkout_time": "وقت تسجيل دخول / وقت الخروج",
    "bookingDetails.keyless_active_switch": "نشط",
    "bookingDetails.keyless_invoke": "إبطال المفتاح",
    "booking.loyalty_program": "برنامج الولاء",
    "bookingDetails.room": "غرفة",
    "bookingDetails.room_info": "لا معلومات الغرفة",
    "bookingDetails.gender": "جنس",
    "bookingDetails.genderFemale": "أنثى",
    "bookingDetails.genderMale": "ذكر",
    "bookingDetails.tp_id": "معرف موارد الطرف الثالث (PMS - معرف الموارد)",
    "bookingDetails.nationality": "جنسية",
    "bookingDetails.startPlaceHolder": "بداية",
    "bookingDetails.endPlaceHolder": "نهاية",
    "bookingDetails.select_one": "حدد واحد",
    "bookingDetails.checkin": "تسجيل دخول",
    "bookingDetails.checkout": " تسجيل خروج",
    "bookingDetails.back_button": "خلف",
    "bookingDetails.last_update": "اخر تحديث: ",
    "bookingDetails.created_at": "أنشئت في: ",
    "bookingDetails.Loyalty_and_preferences": "ولاء وتفضيلات النزلاء",
    "bookingDetails.loyalty_point": "نقطة الولاء",
    "bookingDetails.guest_preferences": "تفضيلات الضيف",
    "bookingDetails.check_with_pms": "كرر التحقق من PMS",
    "bookingDetails.check_with_pms_button": "تحقق من PMS",
    "menu.easee": "إيزي",
    "menu.webeeadmin": "مشرف ويب",
    "template.newTemplate": "قالب جديد",
    "template.language": "لغة",
    "template.title": "عنوان",
    "template.text": "نص",
    "template.choose": "اختر رسالة القالب الخاصة بك",
    "template.chooseLang": "اختار اللغة",
    "template.add": "إضافة قالب جديد",
    "template.edit": "قالب تحرير",
    "template.save": "يحفظ",
    "template.cancel": "يلغي",
    "template.noTemplate": "لا توجد رسالة قالب ، يمكنك إنشاء رسالة قالب.",
    "template.delete": "هل أنت متأكد أنك تريد حذف هذا القالب؟",
    "template.delete-title": "حذف قالب",
    "template.delete-button": "حذف",
    "ringTone.sound": "صوت النغمات",
    "ringTone.playChoose": "العب / اختر",

    /* 11 MODAL */
    "modal.close": "Close",

    // 12 Announcement
    "announcement.popupSubject": "ميزة جديدة: طريقة سهلة للإبلاغ عن مشكلة!",
    "announcement.popupBody":
      'إذا كانت لديك أي مشكلة أو اقتراح بخصوص StaffApp، فيمكنك الانتقال إلى علامة التبويب "الإبلاغ عن مشكلة" ضمن "الإعدادات" والإبلاغ عن مشكلاتك بسهولة إلى فريق الدعم.'
  };
};
